export { EventMetadata } from './EventMetadata';
export type { EventMetadataProps } from './EventMetadata';
